import React from "react"
import ReactDOM from "react-dom/client"
import { CacheProvider } from "@emotion/react"
import createCache from "@emotion/cache"
import SharePointTreeView, { SharePointTreeViewProps } from "./SharePointTreeView"

export const EVENT_SHARING_DONE = "sharing-done"
export const EVENT_SHARING_CANCEL = "sharing-cancel"

export class SharePointTreeViewElement extends HTMLElement {
  private mountPoint: ShadowRoot
  private root?: ReactDOM.Root

  static get observedAttributes() {
    return ["docid", "snapshotid", "filename"]
  }

  constructor() {
    super()
    this.mountPoint = this.attachShadow({ mode: "open" })
  }

  connectedCallback() {
    this.render()
  }

  attributeChangedCallback() {
    this.render()
  }

  destruct() {
    this.root?.unmount()
    this.remove()
  }

  dispatchSharingDoneEvent(message: string | null = null, isOpenFileInSharePoint: boolean) {
    this.dispatchSharingEvent(EVENT_SHARING_DONE, message, { isOpenFileInSharePoint })
  }

  dispatchSharingCancelEvent(message: string | null = null) {
    this.dispatchSharingEvent(EVENT_SHARING_CANCEL, message)
  }

  dispatchSharingEvent(event_name: string, message: string | null, data = {}) {
    const event = new CustomEvent(event_name, {
      detail: { message: message || "", ...data },
      bubbles: true,
      composed: true,
    })
    this.dispatchEvent(event)
  }

  handleOnDone = (isOpenFileInSharePoint: boolean) => {
    this.destruct()
    this.dispatchSharingDoneEvent(null, isOpenFileInSharePoint)
  }

  handleOnCancel = () => {
    this.destruct()
    this.dispatchSharingCancelEvent()
  }

  private render() {
    const cache = createCache({
      key: "mui",
      prepend: true,
      container: this.mountPoint,
    })

    if (!this.root) {
      this.root = ReactDOM.createRoot(this.mountPoint)
    }

    const props: SharePointTreeViewProps = {
      docId: this.getAttribute("docid") ?? "",
      snapshotId: this.getAttribute("snapshotid") ?? "",
      filename: this.getAttribute("filename") ?? "",
      container: this.mountPoint,
    }

    this.root.render(
      <CacheProvider value={cache}>
        <SharePointTreeView
          onDone={this.handleOnDone}
          onCancel={this.handleOnCancel}
          {...props}
        />
      </CacheProvider>
    )
  }
}

customElements.define("sharepoint-nav", SharePointTreeViewElement)
